import React from "react";
import MarketingNavbar from "../MarketingNavbar/MarketingNavbar";
import MarketingFooter from "../MarketingFooter/MarketingFooter";
import {
  PRIVACY_BETA_NOTICE_HTML,
  PRIVACY_SECTIONS,
  PRIVACY_SIDEPANEL_HTML,
} from "../../../content/marketingCopy";

export default function PrivacyPage() {
  // Dynamic Last Updated (kept in component for accuracy)
  const lastUpdatedISO = new Date().toISOString();
  const lastUpdated = new Date(lastUpdatedISO).toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="d-flex flex-column min-vh-100 bg-body text-body">
      <MarketingNavbar />

      <main className="container py-5">
        {/* Header */}
        <header className="mb-4" id="top">
          <p className="text-uppercase text-muted mb-2 small">Legal</p>
          <h1 className="h3 fw-bold mb-2">Privacy Policy</h1>
          <p className="text-muted mb-0">
            Last updated: <time dateTime={lastUpdatedISO}>{lastUpdated}</time>
          </p>
          <div
            className="mt-3"
            dangerouslySetInnerHTML={{ __html: PRIVACY_BETA_NOTICE_HTML }}
          />
        </header>

        <div className="row g-4">
          <div className="col-12 col-lg-8">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4 p-lg-5">
                {/* TOC */}
                <nav aria-label="Table of contents" className="mb-4">
                  <ul className="list-unstyled mb-0">
                    {PRIVACY_SECTIONS.map((s) => (
                      <li key={s.id} className="mb-1">
                        <a className="link-primary text-decoration-none" href={`#${s.id}`}>
                          {s.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </nav>

                {/* Sections */}
                {PRIVACY_SECTIONS.map((s) => (
                  <section id={s.id} className="pt-4 mt-2" key={s.id}>
                    <h2 className="h5 fw-semibold mb-3">{s.title}</h2>
                    <div dangerouslySetInnerHTML={{ __html: s.html }} />
                  </section>
                ))}

                <div className="d-flex mt-4">
                  <a href="#top" className="ms-auto small link-secondary text-decoration-none">
                    Back to top ↑
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Side panel */}
          <aside className="col-12 col-lg-4">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div dangerouslySetInnerHTML={{ __html: PRIVACY_SIDEPANEL_HTML }} />
              </div>
            </div>
          </aside>
        </div>
      </main>

      <MarketingFooter />
    </div>
  );
}
